export function getBrowserTimezone(): string | undefined {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
}

export function withBrowserTimezone<T extends { timezone?: string }>(params: T): T {
  if (params.timezone) {
    return params;
  }
  return { ...params, timezone: getBrowserTimezone() } as T;
}

export function withCycleStartTimezone<
  T extends { group_by_cycle_start_day?: boolean; timezone?: string },
>(params: T): T {
  const groupByCycleStartDay = params.group_by_cycle_start_day ?? true;
  const paramsWithDefault = {
    ...params,
    group_by_cycle_start_day: groupByCycleStartDay,
  } as T;

  if (!groupByCycleStartDay || params.timezone) {
    return paramsWithDefault;
  }
  return { ...paramsWithDefault, timezone: getBrowserTimezone() } as T;
}
